/* BRG — Emulsion Landing Page v3 shared behavior.
   Loaded (defer) by every elv3-* section; the init flag keeps the
   delegated handlers single-instance no matter how many sections load it. */
(function () {
  if (window.__brgElv3Init) return;
  window.__brgElv3Init = true;

  var CHECK_SVG =
    '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 8.4l3.2 3.2L13 5"/></svg>';

  function smoothScrollTo(id) {
    var el = document.getElementById(id);
    if (!el) return;
    window.scrollTo({
      top: el.getBoundingClientRect().top + window.scrollY - 12,
      behavior: 'smooth'
    });
  }

  /* Sync the theme's header cart badge (xo-cart-size custom elements render
     a private store's size — set their text directly from the live cart). */
  function refreshCartCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll('xo-cart-size').forEach(function (el) {
          el.innerText = String(cart.item_count);
        });
      })
      .catch(function () {});
  }

  /* Re-render the cart drawer section so its contents reflect AJAX adds —
     the theme renders it once at page load and its internal store doesn't
     see cart changes made outside its own components. */
  function refreshCartDrawer() {
    var mini = document.querySelector('xo-cart-mini');
    var host = mini && mini.closest('[id^="shopify-section"]');
    if (!host) return;
    var sectionId = host.id.replace(/^shopify-section-/, '');
    fetch('/?sections=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        var html = data && data[sectionId];
        if (!html) return;
        var tpl = document.createElement('div');
        tpl.innerHTML = html;
        var fresh = tpl.firstElementChild;
        // Swap contents in place (not the node) so the theme editor's
        // section references stay valid and don't repaint stale markup.
        if (fresh) host.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  /* Theme-native add: POST with the cart drawer's section id so Shopify returns
     its re-rendered HTML, then push it into the theme's own xo-cart store (the
     same thing the theme's xo-cart-add does). That updates every xo-cart-size
     badge and the drawer contents through the theme's normal bindings, and the
     drawer can then be opened via the theme's modal API. Returns null when the
     theme store isn't available so callers can fall back to a plain add. */
  function nativeCartAdd(variantId) {
    var mini = document.querySelector('xo-cart-mini');
    var store = window.xoStore;
    if (!mini || !mini.id || !store || typeof store.set !== 'function') return null;
    var body = new FormData();
    body.append('id', String(variantId));
    body.append('quantity', '1');
    body.append('sections', mini.id);
    body.append('sections_url', window.location.pathname);
    return fetch('/cart/add.js', {
      method: 'POST',
      body: body,
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin'
    }).then(function (res) {
      if (!res.ok) throw new Error('add failed');
      return res.json();
    }).then(function (item) {
      store.set('xo-cart', function (prev) {
        return Object.assign({}, prev, {
          size: (prev.size || 0) + 1,
          sections: item.sections || prev.sections,
          item: item,
          addIdLoading: '',
          isAdded: true,
          variantId: String(variantId),
          addErrorMessage: ''
        });
      })('xo-cart/addCartSuccess');
      return item;
    });
  }
  function openCartDrawer() {
    var mini = document.querySelector('xo-cart-mini');
    var modal = mini && mini.closest('xo-modal');
    var name = modal && modal.getAttribute('xo-name');
    if (name && window.xoModal && typeof window.xoModal.open === 'function') {
      window.xoModal.open(name);
      return true;
    }
    return false;
  }

  /* Shared with other landing-page scripts (brg-lx.js). */
  window.brgCart = { refreshCartCount: refreshCartCount, refreshCartDrawer: refreshCartDrawer, nativeCartAdd: nativeCartAdd, openCartDrawer: openCartDrawer };

  /* Apply a discount code to the checkout session without leaving the page —
     GET /discount/CODE sets the discount cookie server-side. */
  function applyDiscount(code) {
    if (!code) return;
    fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
  }

  /* ── Add to cart (delegated) ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-elv3-atc]');
    if (!btn) return;

    var scrollTarget = btn.getAttribute('data-scroll-target');
    if (scrollTarget) {
      e.preventDefault();
      smoothScrollTo(scrollTarget);
      return;
    }

    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!variantId || btn.dataset.busy === 'true') return;
    e.preventDefault();

    btn.dataset.busy = 'true';
    /* Theme-native buttons (snippets/button.liquid) keep their padding on an
       inner wrapper, so swap only the label span when one exists. */
    var labelHost = btn.querySelector('[data-elv3-label], .xo-btn__text') || btn;
    var original = labelHost.innerHTML;

    var afterAdd = btn.getAttribute('data-after-add');
    var request = null;
    if (!afterAdd) {
      // Staying on the page: go through the theme's own cart store so the
      // header badge and drawer update natively.
      request = nativeCartAdd(variantId);
    }
    if (!request) {
      request = fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res;
      });
    }
    request
      .then(function () {
        labelHost.innerHTML = CHECK_SVG + '<span>' + (btn.getAttribute('data-added-label') || 'Added to Cart') + '</span>';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        var code = btn.getAttribute('data-discount-code') || '';
        var after = btn.getAttribute('data-after-add');
        var shipCode = btn.getAttribute('data-ship-code') || '';
        var reset = function () {
          labelHost.innerHTML = original;
          btn.dataset.busy = 'false';
        };
        var navigate = null;
        if (after === 'checkout') {
          // Pass the code in the checkout URL — deterministic, no cookie
          // hand-off (the /discount/ cookie can be lost on preview domains).
          navigate = function () {
            window.location.href = code
              ? '/checkout?discount=' + encodeURIComponent(code)
              : '/checkout';
          };
        } else if (after === 'cart') {
          navigate = function () {
            applyDiscount(code);
            window.location.href = '/cart';
          };
        }

        if (navigate && shipCode) {
          // Pause before checkout so the visitor can grab the free shipping code.
          refreshCartCount();
          refreshCartDrawer();
          showShipModal(btn, shipCode, navigate, reset);
          return;
        }
        if (navigate) { navigate(); return; }
        applyDiscount(code);
        if (!openCartDrawer() || !window.xoStore) {
          refreshCartCount();
          refreshCartDrawer();
        }
        setTimeout(reset, 2400);
      })
      .catch(function () {
        labelHost.innerHTML = original;
        btn.dataset.busy = 'false';
        window.location.href = '/cart/add?id=' + variantId + '&quantity=1';
      });
  });

  /* ── Free shipping code modal (pre-checkout interstitial) ── */
  var shipModalEl = null;
  function showShipModal(btn, shipCode, onContinue, onCancel) {
    var title = btn.getAttribute('data-ship-modal-title') || 'Your free shipping code';
    var message = btn.getAttribute('data-ship-modal-message') || 'Copy this code and apply it at checkout for free shipping.';
    var continueLabel = btn.getAttribute('data-ship-modal-continue') || 'Continue to Checkout';

    if (shipModalEl) shipModalEl.remove();
    shipModalEl = document.createElement('div');
    shipModalEl.className = 'lp-ship-modal-overlay';
    shipModalEl.innerHTML =
      '<div class="lp-ship-modal" role="dialog" aria-modal="true" aria-label="' + title.replace(/"/g, '&quot;') + '">' +
      '  <button type="button" class="lp-ship-modal__x" data-ship-modal-close aria-label="Close">&times;</button>' +
      '  <span class="lp-ship-modal__check">' + CHECK_SVG + '</span>' +
      '  <h3 class="lp-ship-modal__title"></h3>' +
      '  <p class="lp-ship-modal__msg"></p>' +
      '  <button type="button" class="lp-ship-modal__chip" data-elv3-copy="' + shipCode.replace(/"/g, '&quot;') + '" data-copied-label="Copied">' +
      '    <span class="code"></span><span class="act" data-copy-label>Copy</span>' +
      '  </button>' +
      '  <button type="button" class="lp-ship-modal__continue" data-ship-modal-continue></button>' +
      '</div>';
    shipModalEl.querySelector('.lp-ship-modal__title').textContent = title;
    shipModalEl.querySelector('.lp-ship-modal__msg').textContent = message;
    shipModalEl.querySelector('.lp-ship-modal__chip .code').textContent = shipCode;
    shipModalEl.querySelector('[data-ship-modal-continue]').textContent = continueLabel;
    document.body.appendChild(shipModalEl);

    var close = function (cancelled) {
      if (!shipModalEl) return;
      shipModalEl.remove();
      shipModalEl = null;
      document.removeEventListener('keydown', onKey);
      if (cancelled && onCancel) onCancel();
    };
    var onKey = function (e) {
      if (e.key === 'Escape') close(true);
    };
    document.addEventListener('keydown', onKey);
    shipModalEl.addEventListener('click', function (e) {
      if (e.target === shipModalEl || e.target.closest('[data-ship-modal-close]')) {
        close(true);
        return;
      }
      if (e.target.closest('[data-ship-modal-continue]')) {
        close(false);
        onContinue();
      }
    });
    shipModalEl.querySelector('[data-ship-modal-continue]').focus();
  }

  /* ── Copy-to-clipboard chip (free shipping code) ── */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-elv3-copy]');
    if (!chip || chip.dataset.busy === 'true') return;
    e.preventDefault();
    var text = chip.getAttribute('data-elv3-copy') || '';
    if (!text) return;
    var done = function () {
      chip.dataset.busy = 'true';
      var label = chip.querySelector('[data-copy-label]');
      var original = label ? label.textContent : '';
      if (label) label.textContent = chip.getAttribute('data-copied-label') || 'Copied';
      chip.classList.add('is-copied');
      setTimeout(function () {
        if (label) label.textContent = original;
        chip.classList.remove('is-copied');
        chip.dataset.busy = 'false';
      }, 2000);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done).catch(function () {});
    } else {
      var ta = document.createElement('textarea');
      ta.value = text;
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); done(); } catch (err) {}
      document.body.removeChild(ta);
    }
  });

  /* ── Anchor smooth scroll (See the Science etc.) ── */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-elv3-scroll]');
    if (!link) return;
    var id = (link.getAttribute('href') || '').replace('#', '');
    if (!id) return;
    e.preventDefault();
    smoothScrollTo(id);
  });

  /* ── Rotating quotes (results split) ── */
  function initQuotes(root) {
    root.querySelectorAll('[data-elv3-quotes]').forEach(function (wrap) {
      if (wrap.dataset.bound === 'true') return;
      wrap.dataset.bound = 'true';
      var quotes = wrap.querySelectorAll('blockquote');
      if (quotes.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var i = 0;
      setInterval(function () {
        quotes[i].style.display = 'none';
        i = (i + 1) % quotes.length;
        var q = quotes[i];
        q.style.display = '';
        q.style.animation = 'none';
        void q.offsetWidth; /* restart entrance animation */
        q.style.animation = '';
      }, parseInt(wrap.getAttribute('data-interval'), 10) || 6000);
    });
  }

  /* ── Sticky bar reveal ── */
  function initSticky(root) {
    root.querySelectorAll('[data-elv3-sticky]').forEach(function (bar) {
      if (bar.dataset.bound === 'true') return;
      bar.dataset.bound = 'true';
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 620;
      var onScroll = function () {
        bar.hidden = window.scrollY <= threshold;
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    });
  }

  function initAll(root) {
    initQuotes(root);
    initSticky(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target || document);
  });
})();
